import { Injectable } from '@angular/core';
import { ApiService } from '@ebb-v2/ebb-integration';
import { IEngineer } from '@ebb-v2/ebb-integration';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LicensevalidationService {
  constructor(private api: ApiService) {}

  public getLdpLicense(
    licenseNumber: string,
    licenseType: string
  ): Observable<IEngineer> {
    return this.api
      .get(
        `/LicensesValidation/ValidateEngineerLicense?licenseType=${licenseType}&licenseNumber=${licenseNumber}`
      )
      .pipe(map(engg => engg as IEngineer));
  }
  public getIsLicenseCheckEnable(
    
  ): Observable<boolean> {
    return this.api
      .get(
        `/LicensesValidation/IsLicenseCheckEnabled`
      )
      .pipe(map(isenabled => isenabled as boolean));
  }
}
